const apiUrl = process.env.REACT_APP_API_URL;
export const DeleteJutgeUsuariIdPointsId = async (id : string, idBall: string , javamon: any) => {
    try {
        const response = await fetch(`${apiUrl}:8061/jutge/usuaris/${id}/points/${idBall}`, {
            method: 'DELETE',
            headers: {
                'Content-Type': 'application/json'
            },
            body: JSON.stringify(javamon)
        });
        const jsonData = await response.json();
        return jsonData;
    } catch (error) {
        console.log('Error al obtener los datos:', error);
    }
};
